document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('product-form');
  if (!form) return;

  const variantInput = form.querySelector('[data-variant-id]');
  const addButton = form.querySelector('[data-add-to-cart]');
  const optionSelectors = Array.from(form.querySelectorAll('[data-option-selector]'));
  const clearVariantButton = form.querySelector('[data-clear-variant]');
  const priceDisplay = document.querySelector('[data-product-price]');
  const priceMain = priceDisplay?.querySelector('[data-price-main]');
  const stickyCart = document.querySelector('[data-sticky-cart]');
  const stickyButton = document.querySelector('[data-sticky-add]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyStock = document.querySelector('[data-sticky-stock]');
  // "Choose a colour" on a cable sold in colours, "Choose a bundle" on a SIM
  // plan — set by snippets/product-form.liquid from the product's option.
  const chooseLabel = form.dataset.chooseLabel || 'Choose a bundle';
  let currentVariant = optionSelectors.length ? null : undefined;

  // Each variant's stock in the badge's words, its SKU and its photo, from
  // sections/main-product.liquid. Missing on a single-variant product.
  let variantStock = {};
  try {
    variantStock = JSON.parse(document.getElementById('product-variant-stock')?.textContent || '{}') || {};
  } catch (_) {
    variantStock = {};
  }
  const stockBadge = document.querySelector('.cli-buyrow > .cli-stockline');
  const skuTargets = Array.from(document.querySelectorAll('[data-variant-sku]'));
  const featuredImage = document.querySelector('[data-product-featured-image]');

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney && window.theme?.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((Number(cents) || 0) / 100);
  }

  function customerPrice(cents) {
    const price = Number(cents) || 0;
    return priceDisplay?.dataset.reseller === 'true' ? Math.round(price * 0.95) : price;
  }

  function priceRangeText() {
    if (!priceDisplay) return '';
    const min = customerPrice(priceDisplay.dataset.priceMin);
    const max = customerPrice(priceDisplay.dataset.priceMax);
    return min === max ? formatMoney(min) : `${formatMoney(min)} - ${formatMoney(max)}`;
  }

  function setPriceText(text) {
    if (priceMain) priceMain.textContent = text;
    if (stickyPrice) stickyPrice.textContent = text;
  }

  function updateButtons(variant) {
    const hasVariantSelectors = optionSelectors.length > 0;
    const canAdd = variant ? variant.available : !hasVariantSelectors;
    const label = !variant && hasVariantSelectors
      ? chooseLabel
      : canAdd
        ? window.cartStrings?.addToCart || 'Add to basket'
        : window.cartStrings?.soldOut || 'Sold out';

    addButton.disabled = !canAdd;
    addButton.textContent = label;
    if (stickyButton) {
      stickyButton.disabled = !canAdd;
      stickyButton.textContent = label;
    }
  }

  // The badge, the SKU and the photo follow the chosen variant, so a colour
  // the supplier has run out of reads "Out of stock" on the page, not the
  // first colour's "In stock".
  function showVariantDetails(variant) {
    const info = variant ? variantStock[String(variant.id)] : null;
    if (!info) return;

    if (stockBadge) {
      stockBadge.className = `cli-stockline cli-stockline--${info.state}${info.count ? '' : ' cli-stockline--nocount'}`;
      const count = info.count ? `<span class="cli-stockline__count">${info.count}</span>` : '';
      const text = document.createElement('span');
      text.className = 'cli-stockline__text';
      text.innerHTML = '<span class="cli-stockline__dot" aria-hidden="true"></span>';
      text.appendChild(document.createTextNode(info.label));
      stockBadge.innerHTML = count;
      stockBadge.appendChild(text);
    }
    if (info.sku) skuTargets.forEach(target => { target.textContent = info.sku; });
    if (featuredImage && info.image) {
      featuredImage.src = info.image;
      featuredImage.srcset = '';
      if (info.alt) featuredImage.alt = info.alt;
      const wanted = info.image.split('?')[0];
      document.querySelectorAll('[data-product-thumbnail]').forEach(thumbnail => {
        const own = (thumbnail.dataset.fullImage || '').split('?')[0];
        thumbnail.classList.toggle('is-active', own === wanted);
      });
    }
    // The sticky bar keeps its trade wording while the line is in stock.
    if (stickyStock && info.state !== 'in') stickyStock.textContent = info.label;
  }

  function rememberVariant(variant) {
    try {
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', variant.id);
      else url.searchParams.delete('variant');
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (_) {
      // The address bar is a convenience; the basket uses the hidden input.
    }
  }

  function clearVariantSelection() {
    optionSelectors.forEach(select => {
      select.value = '';
    });
    showPendingVariantState();
    rememberVariant(null);
    if (clearVariantButton) clearVariantButton.hidden = true;
  }

  function showPendingVariantState() {
    currentVariant = null;
    variantInput.value = '';
    setPriceText(priceRangeText());
    updateButtons(null);
    if (stickyStock) stickyStock.textContent = chooseLabel;
  }

  function updateStickyCartVisibility() {
    if (!stickyCart || !addButton) return;

    const buttonRect = addButton.getBoundingClientRect();
    const header = document.querySelector('[data-sticky-header], .shopify-section-header-sticky, .header-wrapper, .site-header, .header');
    const headerOffset = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    const buttonAboveViewport = buttonRect.bottom <= headerOffset;
    const buttonVisible = buttonRect.bottom > headerOffset && buttonRect.top < window.innerHeight;
    const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
    const shouldShow = isMobileViewport
      ? !buttonVisible
      : window.scrollY > 0 && buttonAboveViewport && !buttonVisible;

    stickyCart.classList.toggle('is-visible', shouldShow);
    stickyCart.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  }

  if (stickyCart && addButton) {
    stickyCart.setAttribute('aria-hidden', 'true');

    if ('IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(updateStickyCartVisibility, {
        root: null,
        threshold: 0
      });
      stickyObserver.observe(addButton);
    }

    window.addEventListener('scroll', updateStickyCartVisibility, { passive: true });
    window.addEventListener('resize', updateStickyCartVisibility);
    updateStickyCartVisibility();
  }

  function loadVariants() {
    if (!window.productVariants) {
      window.productVariants = JSON.parse(document.getElementById('product-variants-json')?.textContent || '[]');
    }
    return window.productVariants;
  }

  function getSelectedVariant() {
    const options = optionSelectors.map(s => s.value);
    if (options.some(option => !option)) return null;
    return loadVariants().find(v => {
      if (v.options.length !== options.length) return false;
      return v.options.every((opt, i) => opt === options[i]);
    });
  }

  // The variant in the address (?variant=, from a colour-filtered card or a
  // shared link) starts selected; otherwise the first available one, so a
  // product with versions opens ready to buy instead of demanding a choice
  // before showing a price. The Clear button still returns the picker to its
  // unselected state.
  function selectDefaultVariant() {
    if (!optionSelectors.length) return;
    const variants = loadVariants();
    let requested = null;
    try {
      const id = new URL(window.location.href).searchParams.get('variant');
      if (id) requested = variants.find(v => String(v.id) === id) || null;
    } catch (_) {
      requested = null;
    }
    const preferred = requested || variants.find(v => v.available) || variants[0];
    if (!preferred) {
      clearVariantSelection();
      return;
    }
    optionSelectors.forEach((select, index) => {
      select.value = preferred.options[index] ?? '';
    });
    optionSelectors[0].dispatchEvent(new Event('change'));
  }

  let settled = false;
  optionSelectors.forEach(select => {
    select.addEventListener('change', () => {
      const variant = getSelectedVariant();
      if (variant) {
        currentVariant = variant;
        variantInput.value = variant.id;
        setPriceText(formatMoney(customerPrice(variant.price)));
        updateButtons(variant);
        if (stickyStock) stickyStock.textContent = variant.available ? 'In stock for trade orders' : 'Back order available';
        showVariantDetails(variant);
        // The opening pick is the page's default, not the customer's choice:
        // the address only changes once they choose.
        if (settled) rememberVariant(variant);
        if (clearVariantButton) clearVariantButton.hidden = false;
      } else {
        showPendingVariantState();
        if (clearVariantButton) {
          clearVariantButton.hidden = !optionSelectors.some(optionSelector => optionSelector.value);
        }
      }
    });
  });

  if (clearVariantButton) {
    clearVariantButton.addEventListener('click', clearVariantSelection);
  }

  if (stickyButton) {
    stickyButton.addEventListener('click', () => {
      addButton?.click();
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (optionSelectors.length && !currentVariant) {
      alert(`${chooseLabel} before adding this product.`);
      return;
    }

    addButton.disabled = true;
    if (stickyButton) stickyButton.disabled = true;
    try {
      await window.addItemToCart(new FormData(form));
      window.showCartNotification();
      const count = document.querySelector('[data-cart-count]');
      if (count) {
        const current = parseInt(count.textContent, 10) || 0;
        count.textContent = current + parseInt(form.querySelector('[name="quantity"]').value || 1, 10);
      }
    } catch (err) {
      alert(window.cartStrings?.error || 'Could not add item to cart');
    } finally {
      updateButtons(currentVariant);
    }
  });

  if (optionSelectors.length) {
    selectDefaultVariant();
  }
  settled = true;
});
